export default "__VITE_ASSET__B3RA3MAJ__"